// generated from 28 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const medianSessionDurationFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("median_session_duration_filter"),
  comparison_key: z.enum([
    "5", // 12 (42.86%)
    "3", // 6 (21.43%)
    "1", // 5 (17.86%)
    "4", // 5 (17.86%)
  ]),
  display_name: z.string(),
  // undefined: 17 (60.71%), defined 11 (39.29%)
  raw_value: z.int().min(1).optional(),
  value: z.int().min(1),
  varies_by_app_group: z.literal(false),
});
